import styled from "styled-components";
import { Box } from "rebass/styled-components";

export const Centered = styled(Box)`
  margin: auto;
  padding: ${(p) => p.theme.space[3]};
  width: 100%;
  max-width: ${(p) => p.theme.maxContentWidth};
`;
